

import { makeStyles, Theme, createStyles, Paper } from "@material-ui/core";
import { observer } from "mobx-react";
import { FormPage as FormPageType } from "../../../../stores/models/FormPage";
import FormSection from "./FormSection";
import { Fragment } from "react";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        paper: {
            padding: theme.spacing(0, 2, 2, 2),
            marginTop: theme.spacing(2),
            whiteSpace: 'pre-line',
            wordBreak: 'break-word',
            overflow: 'hidden'
        },
    }),
);

interface FormPageProps {
    page: FormPageType;
}

const FormPage = observer((props: FormPageProps) => {

    const classes = useStyles();

    /********* Render *********/

    return (
        <Fragment>
            {props.page.sections.map((section, index) => {
                return (
                    <Paper className={classes.paper}>
                        <FormSection section={section} />
                    </Paper>
                )
            })}
        </Fragment>
    );
});

export default FormPage;